import React, { useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { useStyles } from "./AssetNonTitled/AssetNonTitledFormStyles";
import {
	Grid,
	Box,
	IconButton,
	Tooltip,
	Checkbox,
	FormControlLabel} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { actions } from "./AssetReducer";
import useAssetProvider from "./useAssetProvider";
import OriginalAssetDetails from './OverrideDetails/OriginalAssetDetails';
import ManualOverrideDetails from './OverrideDetails/ManualOverrideDetails';
import VinFoundDetails from './OverrideDetails/VinFoundDetails';
import OverrideDetails from './OverrideDetails/OverrideDetails';

const AssetTruckChassis = (props) => {
	const {
		asset,
		conditions,
		findByVin,
		loadYearChoices,
		loadConfigChoices,
		setAssetConfig,
		dispatch,
		setMaualOverride,
		disableManualEdit,
		error
	} = props;
	const classes = useStyles();
	const { isReadOnly } = useAssetProvider();
	const classId = 2;

	useEffect(() => {
		loadYearChoices();
	}, []);

	useEffect(() => {
		if (conditions.edit_asset)
			if (asset?.no_vin_found) {
				setMaualOverride(true);
			} else {
				disableManualEdit();
			}
	}, [asset?.no_vin_found]);

	return (
		<Box>
			<Grid container >
				<Grid container item xs={5} direction="column">
					<OriginalAssetDetails asset={asset} />
				</Grid>
				<Grid container item xs={6} direction="row">
					<Grid container direction="row" alignItems="flex-end">
						<Grid item xs={5}>
							<TextField
								style={{ width: "100%" }}
								id="override-vin"
								label="Override VIN"
								margin="normal"
								value={asset.override_vin || ""}
								disabled={isReadOnly || !conditions.searchVIN || !conditions.edit_asset || asset?.no_vin_found}
								onChange={(e) =>
									dispatch({
										type: actions.OVERRIDE_VIN,
										payload: e.target.value,
									})
								}
							/>
							{error && (
								<span style={{ color: 'red', fontSize: 14 }}>Please provide valid vin</span>
							)}
						</Grid>
						<Grid item xs={5}>
							<FormControlLabel
								disabled={isReadOnly || !conditions.edit_asset}
								className={classes.verticalGap}
								checked={asset?.no_vin_found || false}
								onChange={(e) => {
									dispatch({
										type: actions.UPDATE_NO_VIN_FOUND,
										payload: e.target.checked
									})
								}}
								control={<Checkbox color="primary" name="confirmation" />}
								label="Manual Override"
							/>
						</Grid>
						{!isReadOnly && conditions.edit_asset && (
							<Grid item xs={2}>
								{conditions.searchVIN && (
									<Tooltip title="search" placement="top-end" >
										<IconButton
											color="primary"
											onClick={() => {
												findByVin(document.getElementById("override-vin").value);
											}}>
											<Search />
										</IconButton>
									</Tooltip>
								)}

							</Grid>
						)}
					</Grid>
					{
						!isReadOnly && conditions.edit_asset && (asset?.no_vin_found ? <ManualOverrideDetails asset={asset} conditions={conditions} dispatch={dispatch} />
							: <VinFoundDetails asset={asset} conditions={conditions} dispatch={dispatch} classId={classId}
								loadConfigChoices={loadConfigChoices} setAssetConfig={setAssetConfig} />)
					}
					{
						(isReadOnly || !conditions.edit_asset) && <OverrideDetails asset={asset} conditions={conditions} dispatch={dispatch} />
					}
				</Grid>
				<Grid item xs={11}>
					<TextField
						style={{ width: "100%" }}
						id="engine-selected-make-model"
						label="Engine Make/Model"
						value={
							asset?.engine_selected_manufacturer || asset?.engine_selected_model
								? asset?.engine_selected_manufacturer +
								" " +
								asset?.engine_selected_model
								: "No Engine Make/Model"
						}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={11}>
					<TextField
						style={{ width: "100%" }}
						id="transmission-selected-make-model"
						label="Transmission Make/Model"
						value={
							asset?.trans_selected_manufacturer || asset?.trans_selected_model
								? asset?.trans_selected_manufacturer + " " + asset?.trans_selected_model
								: "No Transmission Make/Model"
						}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
			</Grid>
		</Box>
	);
};
export default AssetTruckChassis;
